export const SEARCH_LOADING = 'SEARCH_LOADING';
export const SEARCH_LOADED = 'SEARCH_LOADED';

export const searchLoaded = (data) => ({
    type: SEARCH_LOADED,
    payload: { data },
});

export const searchLoading = () => ({
    type: SEARCH_LOADING,
    payload: {}
});



// WEBPACK FOOTER //
// ./src/components/Search/searchActions.js